import ExpenseTypes from "@upclaim/prisma/seeds/expenses_types.json";
import { ExpenseTypeSchema as ExpenseTypeDb } from "@/interfaces/data-contracts";

import { TrainFront, BedDouble, CarTaxiFront, PlaneTakeoff, PlaneLanding, UtensilsCrossed, PhoneOutgoing, TentTree, Receipt, Clock4 } from "lucide-vue-next";

export type ExpenseType = ExpenseTypeDb['type'];

const ExpenseTypesMap: { [key in ExpenseType]: { icon: any, value: key; label: string; } } = {
  "TRAIN": { icon: TrainFront, value: "TRAIN", label: "Train" },
  "HOTEL": { icon: BedDouble, value: "HOTEL", label: "Hébergement" },
  "TAXI": { icon: CarTaxiFront, value: "TAXI", label: "Taxi / Uber" },
  "OUTBOUND_FLIGHT": { icon: PlaneLanding, value: "OUTBOUND_FLIGHT", label: "Billet d'avion retour" },
  "RETURN_FLIGHT": { icon: PlaneTakeoff, value: "RETURN_FLIGHT", label: "Billet d'avion aller" },
  "FOOD": { icon: UtensilsCrossed, value: "FOOD", label: "Frais de restauration" },
  "PHONE_PLAN": { icon: PhoneOutgoing, value: "PHONE_PLAN", label: "Hors forfait téléphonique" },
  "TRAVEL_PACKAGE_SERVICE": { icon: TentTree, value: "TRAVEL_PACKAGE_SERVICE", label: "Prestation forfait voyage" },
  "SALARY_COMPENSATION": { icon: Clock4, value: "SALARY_COMPENSATION", label: "Compensation salaire" },
  "OTHER": { icon: Receipt, value: "OTHER", label: "Autre" },
};

export {
  ExpenseTypesMap,
}